import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { TreeNodeProductAttachmentList } from "../ListEntity/TreeNodeProductAttachmentList";
import { TreeNodeSubstanceAttachmentFieldsList } from "../ListEntity/TreeNodeSubstanceAttachmentFieldsList";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { Attachment } from "../../../Data/Art57Data/Attachment";
import { ErrorType } from "../../ErrorType";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { TreeNodeProductsList } from "../ListEntity/TreeNodeProductsList";
import { TreeNodeSubstancesList } from "../ListEntity/TreeNodeSubstancesList";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";
import { Util } from "../../../Util";

export class TreeNodeAttachmentType extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new Attachment(new FieldDefinition(injector)),
        '{param1}{param2}{param3}'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Attachment';
      this.data.model.operationtype = 1;
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      if (this.data && this.data.model && this.data.model.operationtype) {
        this.label = this.labelTemplate
          .replace('{param1}',
            this.data.model.operationtype
              ?this.ioc!.get(LookupGetService).retrieveValueFromCache(
                'operationtype',
                this.data.model.operationtype
              )
              : ''
          )
          .replace(
            '{param2}',
            this.data.model && this.data.model.languagecode
              ? ' - ' +
              this.ioc!.get(LookupGetService).retrieveValueFromCache(
                'language',
                this.data.model.languagecode
              )
              : ''
          )
          .replace(
            '{param3}',
            this.data.model && this.data.model.attachmentname
              ? ' - ' + this.data.model.attachmentname
              : ''
          );
      } else {
        this.label = this.labelTemplate
          .replace('{param1}', '')
          .replace('{param2}', '')
          .replace('{param3}', '');
      }
    }
  
  override getListItem(): any[] {
    return [
      this.data.model && this.data.model.ev_Code
        ? this.data.model.ev_Code
        : '-',
      this.data.model && this.data.model.operationtype
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'operationtype',
          this.data.model.operationtype
        )
        : '-',
      this.data.model && this.data.model.attachmenttype
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'attachmenttype',
          this.data.model.attachmenttype
        )
        : 'Attachment Type',
      this.data.model && this.data.model.attachmentname
        ? this.data.model.attachmentname
        : 'Attachment Name',
      '',
    ];
  }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeAttachmentType = new TreeNodeAttachmentType(
        this.ioc!,
        newParent
      );
  
      const currentLocalNumber = this.ioc!.get(LookupGetService).getNodeLocalNumber(clonedNode, this);
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.data.model.localnumber = currentLocalNumber;
      clonedNode.data.model.file = this.data.model.file;
    

      if (clonedNode.parent != this.parent) {
        this.ioc?.get(Art57Section).showWarningTooltipMessage('Please note that attachments referenced in this XEVPRM with an \'Insert\' operation type must be attached again using the \'here\' link in the \'Attachments\' section (highlighted in red) within the tree-view area.');
      }
      this.ioc!.get(LookupGetService).fixLocalNumber(clonedNode.data.model.localnumber);

      if (!Number.isNaN(Number(clonedNode.data.model.localnumber))) { // local number is number
        clonedNode.data.model.filename = "Attachment" + Math.abs(clonedNode.data.model.localnumber).toString().padStart(2, '0'); 
      } else { // localnumber is not a number
        clonedNode.data.model.filename = "Attachment" + clonedNode.data.model.localnumber; 
      }
      
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
    
    existsPPIAttachment(AuthorisedProductsRootNodeList: any, localnumber: any): boolean {
      let existNode: boolean = false;
  
      for (let i = 0; i < AuthorisedProductsRootNodeList?.children?.length; i++) {
        const productsAttachmentChildrens = Art57NodeUtils.findFirstChildNodeOfType(
          AuthorisedProductsRootNodeList.children[i],
          TreeNodeProductAttachmentList);
          if (productsAttachmentChildrens?.children && Array.isArray(productsAttachmentChildrens.children)) {
            for(let j=0; j < productsAttachmentChildrens?.children?.length; j++) {
              const childAttachment = productsAttachmentChildrens.children[j];
              if (childAttachment &&
                  childAttachment.data.model.attachmentcode.resolutionmode == 1 &&
                  childAttachment.data.model.attachmentcode.value == localnumber) {
                existNode = true;
                break;
              }  
            }
          }
          if (existNode) {
            break;
          }
      }
  
      return existNode;
    }
  
    existsPSIAttachment(ApprovedSubstancesRootNodeList: any, localnumber: any): boolean {
      let existNode: boolean = false;
  
      for (let i = 0; i < ApprovedSubstancesRootNodeList?.children?.length; i++) {
        const productsAttachmentChildrens = Art57NodeUtils.findFirstChildNodeOfType(
          ApprovedSubstancesRootNodeList.children[i],
          TreeNodeSubstanceAttachmentFieldsList);
          if (productsAttachmentChildrens?.children && Array.isArray(productsAttachmentChildrens.children)) {
            for(let j=0; j < productsAttachmentChildrens?.children?.length; j++) {
              const childAttachment = productsAttachmentChildrens.children[j];
              if (childAttachment &&
                  childAttachment.data.model.attachmentcode.resolutionmode == 1 &&
                  childAttachment.data.model.attachmentcode.value == localnumber) {
                existNode = true;
                break;
              }  
            }
          }
          if (existNode) {
            break;
          }
      }
  
      return existNode;
    }

    override validateBusinessRules(): any[] {
      let errors: any = [];
      let productsAttachmentsNodeList = Art57NodeUtils.findFirstChildNodeOfType(this.parent!.parent,TreeNodeProductsList);
      let substancesAttachmentsNodeList = Art57NodeUtils.findFirstChildNodeOfType(this.parent!.parent,TreeNodeSubstancesList);
  
      if (
        this.data.model.attachmenttype == 1 &&
        !this.existsPPIAttachment(
          productsAttachmentsNodeList,
          this.data.model.localnumber
        )
      ) {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: 'PPI attachment is not referenced in any entity',
        });
      } else if (
        this.data.model.attachmenttype == 2 &&
        !this.existsPSIAttachment(
          substancesAttachmentsNodeList,
          this.data.model.localnumber
        )
      ) {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: 'PSI attachment is not referenced in any entity',
        });
      }else if ((this.data.model.file) && 
                (this.data.model.file[0].size > environment.maxIndividualByteSize)){
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: 'Attachment size exceed maximum size allowed: ' + Util.formatFileSize(environment.maxIndividualByteSize, 0),
        });
      } else {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.errorInactive,
          controlId: undefined,
          controlLabel: '',
          error: '',
        });
      }



      const businessRulesErrors = ErrorControlUtil.sameReferenceByValue(this, "localnumber");
      if (businessRulesErrors.length === 2) {
        errors.push(businessRulesErrors[0]);
      }

      return errors;
    }

  }